/**
 * Три рабочие зоны одного аккаунта и их имена — в одном месте.
 *
 * Переключатель зон, шапка сайта и страница «такой страницы нет» называют зоны
 * одинаково: когда кнопка в шапке говорит «Мои встречи», а переключатель в
 * кабинете — что-то другое, человек ищет третью зону, которой нет.
 */
import type { Lang } from '@/i18n/translations'

export type WorkspaceKey = 'friends' | 'meetings' | 'practice'

export const WORKSPACES: Record<WorkspaceKey, { path: '/cabinet' | '/my' | '/cabinet/practice'; label: Record<Lang, string> }> = {
  friends: { path: '/cabinet', label: { ru: 'Книга друзей', en: 'Friends book' } },
  meetings: { path: '/my', label: { ru: 'Мои встречи', en: 'My therapy' } },
  // «Моя», как и в английском: в шапке сайта рядом стоит страница «Практика»
  // для психологов, и две одноимённые ссылки в разные места читались одной.
  practice: { path: '/cabinet/practice', label: { ru: 'Моя практика', en: 'My practice' } },
}

/** Зона, в которой человек сейчас, по адресу. */
export function workspaceOf(path: string): WorkspaceKey {
  if (path === '/my' || path.startsWith('/my/')) return 'meetings'
  if (path === '/cabinet/practice' || path.startsWith('/cabinet/practice/')) return 'practice'
  return 'friends'
}
